/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { forwardRef } from 'react';

import { TextField } from '@coursera/cds-core';
import type { TextFieldProps } from '@coursera/cds-core';

import _t from 'i18n!nls/authentication';

type PropsFromCaller = {
  label?: string;
  name?: string;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  autoComplete?: 'name' | 'given-name' | 'family-name';
};

type PropsToComponent = PropsFromCaller &
  Omit<TextFieldProps, keyof PropsFromCaller> & {
    value?: string | number;
  };

const NameInput = forwardRef<HTMLInputElement, PropsToComponent>(
  (
    {
      label = _t('Full Name'),
      name = 'name',
      placeholder = _t('Enter your full name'),
      autoComplete = 'name',
      ...props
    }: PropsToComponent,
    ref
  ) => {
    return (
      <TextField
        label={label}
        name={name}
        placeholder={placeholder}
        autoComplete={autoComplete}
        ref={ref}
        necessityIndicator="icon"
        {...props}
      />
    );
  }
);
export default NameInput;
